export default "__VITE_ASSET__X3e2TxSp__"